import ExportVehicleCertModal from './export-vehicle-cert-modal.vue'
export default ExportVehicleCertModal
